import React from 'react';
import { useSubscription } from '../../Context/SubscriptionContext';
import UpgradeScreen from './UpgradeScreen';

/**
 * FeatureGuard Component
 * Wraps content that requires specific subscription/feature access
 */
const FeatureGuard = ({ 
    feature, 
    context = {}, 
    children, 
    fallback = null, 
    showUpgradeScreen = true 
}) => {
    const { canAccessFeature, subscription } = useSubscription();

    if (subscription.loading) {
        return <div className="animate-pulse bg-gray-800 h-24 w-full rounded-lg"></div>;
    }

    const hasAccess = canAccessFeature(feature, context);

    if (hasAccess) {
        return <>{children}</>;
    }

    if (fallback) {
        return <>{fallback}</>;
    }

    if (showUpgradeScreen) {
        return <UpgradeScreen feature={feature} />;
    }

    return null;
};

export default FeatureGuard;
